import createIcon from '../../createIcon';

/**
 * @component @name WineBar
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNiAzVjlDNiAxMS45NyA4LjE2IDE0LjQzIDExIDE0LjkxVjE5SDhWMjFIMTZWMTlIMTNWMTQuOTFDMTUuODQgMTQuNDMgMTggMTEuOTcgMTggOVYzSDZaTTE2IDhIOFY1SDE2VjhaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const WineBar = createIcon('WineBar', [
  [
    'path',
    {
      d: 'M6 3V9C6 11.97 8.16 14.43 11 14.91V19H8V21H16V19H13V14.91C15.84 14.43 18 11.97 18 9V3H6ZM16 8H8V5H16V8Z',
      key: '1j4e7n',
    },
  ],
]);

export default WineBar;
